import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component'; 
import { environment } from './environments/environment';
import { appConfig } from './app/app.config';


if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
// platformBrowserDynamic()
//     .bootstrapModule(AppModule)
//     .then((module) =>
//         enableDebugTools(module.injector.get(ApplicationRef).components[0]),
//     )
//     .catch((err) => console.error(err));
